import React from 'react';
import '../App.css';

function Leaderboard({ submissions, requirements }) {
  const calculateScore = (submission) => {
    if (!submission.scores) return 0;
    return Object.values(submission.scores).reduce((sum, score) => sum + (parseInt(score) || 0), 0);
  };

  const sortedSubmissions = [...submissions]
    .map(sub => ({
      ...sub,
      totalScore: calculateScore(sub)
    }))
    .sort((a, b) => b.totalScore - a.totalScore);

  const requirementsLength = Array.isArray(requirements) ? requirements.length : 0;

  if (submissions.length === 0) {
    return (
      <div className="leaderboard-section">
        <h3 style={{ color: '#ffffff', marginBottom: '1rem', fontSize: '1.25rem' }}>Leaderboard</h3>
        <p style={{ color: 'rgba(255, 255, 255, 0.5)', fontStyle: 'italic' }}>
          No submissions yet. Submit designs to see the leaderboard.
        </p>
      </div>
    );
  }

  return (
    <div className="leaderboard-section">
      <h3 style={{ color: '#ffffff', marginBottom: '1rem', fontSize: '1.25rem' }}>Leaderboard</h3>
      <div className="leaderboard-list">
        {sortedSubmissions.map((submission, index) => (
          <div 
            key={submission.id}
            style={{
              padding: '1rem',
              marginBottom: '0.5rem',
              background: index === 0 
                ? 'rgba(255, 193, 7, 0.15)' 
                : 'rgba(255, 255, 255, 0.05)',
              borderRadius: '8px',
              border: index === 0 
                ? '2px solid rgba(255, 193, 7, 0.5)' 
                : '1px solid rgba(255, 255, 255, 0.1)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              transition: 'all 0.2s ease'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <span style={{
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: index === 0 ? '#FFC107' : 'rgba(255, 255, 255, 0.7)',
                minWidth: '30px'
              }}>
                #{index + 1}
              </span>
              <div>
                <strong style={{ color: '#ffffff' }}>{submission.designerName}</strong>
                <div style={{ fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.6)', marginTop: '0.25rem' }}>
                  {submission.scores && requirementsLength > 0
                    ? `${Object.values(submission.scores).filter(s => s > 0).length}/${requirementsLength} requirements met`
                    : 'Not scored yet'}
                </div>
              </div>
            </div>
            <div style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              color: index === 0 ? '#FFC107' : '#D702F6'
            }}>
              {submission.totalScore} pts
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Leaderboard;
